import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Content from "../sections/Teamdetail/Content";

class Teamdetail extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Aglosi | Account Detail</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />
        <Content />
        <Footer />
      </Fragment>
    );
  }
}

export default Teamdetail;
